export default __webpack_public_path__ + "static/media/EM1950.34I-43217_-25842_0.d07e9406.jpg";